<template>
	<div>
		<ob-spinner v-if="gcLoader" loading-text="Loading..."></ob-spinner>
		<div class="ead-container" v-else>
			<div class="row ead-header" v-if="!isNoDataAvailable">
				<div class="col-md-12 p0" style="border-bottom: 1px dashed #ccc;"
					v-if="docList1 != null && docList1.length > 0 && checkDataexisting(docList1)">
					<div class="col-md-12 header-heading" style="margin-top:20px;">
						<div class="col-md-8" style="padding-left: 0px;">
							<h4 style="font-weight: 600;font-size: 15px;color:#143361">APPROVED GREEN CARD</h4>
						</div>
					</div>
					<ob-ead-document :previousList="l.IsExpired" :documentList="l" :entireData="{}" :key="`documentlist-${index}`"
						v-for="(l, index) in docList1"> </ob-ead-document>
				</div>
				<!-- <div class="col-md-12 p0" style="margin-top:20px;border-bottom: 1px dashed #ccc;" v-if="docList3 != null && docList3.length > 0 && checkDataexisting(docList3)"> -->

					<div class="col-md-12 header-heading" style="margin-top:20px;border-bottom: 1px dashed #ccc;"
						v-if="docList2 != null && docList2.length > 0">
						<h4 style="font-weight: 600;font-size: 15px;color:#143361">ADJUSTMENT OF STATUS</h4>
						<ob-ead-document :previousList="l.IsExpired" :documentList="l" :entireData="{}" :key="`documentlist-${index}`"
							v-for="(l, index) in docList2"> </ob-ead-document>
					</div>
				<div class="col-md-12 header-heading" style="margin-top:20px;border-bottom: 1px dashed #ccc;" v-if="(docList3 != null && docList3.length > 0) || (docList4 != null && docList4.length > 0)">
					<div class="col-md-8" style="padding-left: 0px;" >
						<h4 style="font-weight: 600;font-size: 15px;color:#143361">FORM I-140</h4>
					</div>
					<ob-ead-document :previousList="l.IsExpired" :documentList="l" :entireData="{}" :key="`documentlist-${index}`"
						v-for="(l, index) in docList3"> </ob-ead-document>
					<ob-ead-document :previousList="l.IsExpired" :documentList="l" :entireData="{}" :key="`documentlist-${index}`"
						v-for="(l, index) in docList4"> </ob-ead-document>
				</div>
				<div class="col-md-12 header-heading" style="margin-top:20px;border-bottom: 1px dashed #ccc;"
					v-if="docList5 != null && docList5.length > 0">
					<h4 style="font-weight: 600;font-size: 15px;color:#143361">PERM LABOR CERTIFICATION</h4>
					<ob-ead-document :previousList="l.IsExpired" :documentList="l" :entireData="{}" :key="`documentlist-${index}`"
						v-for="(l, index) in docList5"> </ob-ead-document>
				</div>

				<div class="col-md-12 header-heading" style="margin-top:20px;" v-if="docList6 != null && docList6.length > 0">
					<h4 style="font-weight: 600;font-size: 15px;color:#143361">PREVAILING WAGE DETERMINATION</h4>
					<ob-ead-document :previousList="l.IsExpired" :documentList="l" :entireData="{}" :key="`documentlist-${index}`"
						v-for="(l, index) in docList6"> </ob-ead-document>
				</div>
			</div>
			<div v-if="isNoDataAvailable" style="height: 400px;display:table;width:100%;">
				<div class="pfa-body" style="display: table-cell; vertical-align: middle;text-align: center;">
					<img :src="`${CDNIMAGESBASEURL}/ess/ESSApp/static/Images/Folder_icon.svg`" style="margin-bottom:20px;" />
					<h5 class="pfa-info_msg">
						Once the employer uploads the Green card, it will be reflected here.
					</h5>
				</div>
			</div>
		</div>
		<!-- Commented for Change Request 99963  (&& isDataExists(docList3))  /Form I-140-->
	</div>
</template>
<script>
export default {
	data() {
		return {
			gcLoader: false,
			groupId: "",
			docList1: [],
			docList2: [],
			docList3: [],
			docList4: [],
			docList5: [],
			docList6: [],
			count: 0,
		};
	},
	created() {

		this.getGCDocuments();
		events.listen("RemovedGCEADDoc", () => {
			this.getGCDocuments();
		});
		events.listen("AddOrUpdateGCEADDoc", () => {
			this.getGCDocuments();
		});
	},
	methods: {
		isDataExists(docList) {
			var isCheck = true;
			if (docList.length > 0) {
				isCheck = docList[0].DocumentId == null || docList[0].DocumentId == "";
				return isCheck;
			}
		},
		checkDataexisting(docList) {
			var isCheck = true;
			if (docList.length > 0) {
				isCheck = docList[0].DocumentId != null && docList[0].DocumentId != "";
				return isCheck;
			}
		},
		getGCDocuments() {

			this.count = 0;
			this.groupId = "EADCard";
			this.gcLoader = true;
			ajax.get(
				`Onboard/GetESSGreenCardetails?consultantId=${loggedInUserObj.consultantId}&orgId=${loggedInUserObj.orgId}`,
				{},
				(res) => {

					if (res.data.State) {
						this.docList1 = res.data.ApprovedGreenCard ?  res.data.ApprovedGreenCard.ListOfDocuments : [];
						this.docList2 = res.data.FormI485 ?  res.data.FormI485.ListOfDocuments : [];
						this.docList3 = res.data.FormI140Application ?  res.data.FormI140Application.ListOfDocuments : [];
						this.docList4 = res.data.ApprovedFormI140 ? res.data.ApprovedFormI140.ListOfDocuments : [];
						this.docList5 = res.data.ETA9089 ?  res.data.ETA9089.ListOfDocuments : [];
						this.docList6 = res.data.ETA9141 ?  res.data.ETA9141.ListOfDocuments : [];
						// this.docList6 = res.data.ETA9089 ?  res.data.ETA9089.ListOfDocuments : [];

						setTimeout(() => {
								this.gcLoader = false;

							}, 2000);
						console.log(this.docList1,this.docList2,this.docList3,this.docList4, this.docList5,this.docList6, "test")
					}
				}
				);

			// ajax.get(
			// 	`/OnBoard/${loggedInUserObj.consultantId}/{}/GetDocumentList?group=${this.groupId}&orgId=${loggedInUserObj.orgId}&isGreenCard=true&isESSGreenCard=true`,
			// 	{},
			// 	(res) => {
			// 		if (res.data.State == true) {
			// 			this.docList1 = res.data.ListOfDocuments;
			// 			console.log("docList1", this.docList1);
			// 			this.docList1.forEach((d) => {
			// 				// d.CanESign = true
			// 				this.$set(d, "jobid", this.$route.query.jobId);
			// 			});
			// 			setTimeout(() => {
			// 				this.gcLoader = false;
			// 			}, 2000);
			// 			// this.count = this.count + 1
			// 		} else {
			// 			this.$message({
			// 				type: "error",
			// 				message: res.data.Message,
			// 			});
			// 		}
			// 	}
			// );

			// Commnted code for Commented for Change Request 99963
			//   //Change Request 80624: Codeforce - Show I-140 approval for the employee in ESS
			// 		ajax.get(`/OnBoard/${loggedInUserObj.consultantId}/{}/GetDocumentList?group=GCFormI140&orgId=${loggedInUserObj.orgId}`, {} , (res) => {
			// 			if(res.data.State == true){
			// 				this.docList3 = res.data.ListOfDocuments;

			// 				this.docList3.forEach((d) => {
			// 					d.CanESign = true
			// 					this.$set(d, 'jobid',this.$route.query.jobId)
			//       });
			//       setTimeout(() => {
			//         this.gcLoader = false
			//       }, 2000)
			// 				this.count = this.count + 1
			//     }
			//     else {
			// 				this.$message({
			// 					type: 'error',
			// 					message: res.data.Message
			// 				})
			// 			}
			// 		})
			// Commented Code in future we need to these below gorup documents
			// ajax.get(`/OnBoard/${loggedInUserObj.consultantId}/{}/GetDocumentList?group=GCStatusAdjustment&orgId=${loggedInUserObj.orgId}`, {} , (res) => {
			// 	if(res.data.State == true){
			// 		this.docList2 = res.data.ListOfDocuments;
			// 		console.log("docList2",this.docList2)

			// 		// this.docList2.forEach((d) => {
			// 		// 	d.CanESign = true
			// 		// 	this.$set(d, 'jobid',this.$route.query.jobId)
			// 		// });
			// 		this.count = this.count + 1
			// 	} else {
			// 		this.$message({
			// 			type: 'error',
			// 			message: res.data.Message
			// 		})
			// 	}
			// })
			// ajax.get(`/OnBoard/${loggedInUserObj.consultantId}/{}/GetDocumentList?group=GCPermLaborCertification&orgId=${loggedInUserObj.orgId}`, {} , (res) => {
			// 	if(res.data.State){
			// 		this.docList4 = res.data.ListOfDocuments;
			// 		console.log("docList4",this.docList4)

			// 		this.docList4.forEach((d) => {
			// 			d.CanESign = true
			// 			this.$set(d, 'jobid',this.$route.query.jobId)
			// 		});
			// 		this.count = this.count + 1
			// 		//this.showGCUploadMethod()
			// 	} else {
			// 		this.$message({
			// 			type: 'error',
			// 			message: res.data.Message
			// 		})
			// 	}
			// })
			// ajax.get(`/OnBoard/${loggedInUserObj.consultantId}/{}/GetDocumentList?group=GCRecruitmentProcess&orgId=${loggedInUserObj.orgId}`, {} , (res) => {
			// 	if(res.data.State){
			// 		this.docList5 = res.data.ListOfDocuments;
			// 		console.log("docList5",this.docList5)

			// 		this.docList5.forEach((d) => {
			// 			d.CanESign = true
			// 			this.$set(d, 'jobid',this.$route.query.jobId)
			// 		});
			// 		this.count = this.count + 1
			// 		//this.showGCUploadMethod()
			// 	} else {
			// 		this.$message({
			// 			type: 'error',
			// 			message: res.data.Message
			// 		})
			// 	}
			// })
			// ajax.get(`/OnBoard/${loggedInUserObj.consultantId}/{}/GetDocumentList?group=GCPrevailingWageDetermination&orgId=${loggedInUserObj.orgId}`, {} , (res) => {
			// 	if(res.data.State){
			// 		this.docList6 = res.data.ListOfDocuments;
			// 		console.log("docList6",this.docList6)

			// 		this.docList6.forEach((d) => {
			// 			d.CanESign = true
			// 			this.$set(d, 'jobid',this.$route.query.jobId)
			// 		});
			// 		this.count = this.count + 1
			// 		//this.showGCUploadMethod()
			// 	} else {
			// 		this.$message({
			// 			type: 'error',
			// 			message: res.data.Message
			// 		})
			// 	}
			// })
		},
	},
	watch: {},
	computed: {
		fileUploadUrl() {
			return `/OnBoard/UpdateDocumentByGroup?consultantId=${loggedInUserObj.consultantId}&jobId=${this.$route.query.jobId}`;
		},
		isNoDataAvailable() {
			if(this.docList1.length < 1  && this.docList2.length < 1 && this.docList3.length < 1  && this.docList4.length < 1 && this.docList5 < 1 && this.docList6 < 1) {
				return true;
		}else{
			return false;
		}
	}
}
}
</script>
<style lang="scss" scoped>.ead-header {
	padding: 15px;
	margin: 0px;
	padding-bottom: 0px;
}

.header-heading {
	padding: 5px 3px 0;
}</style>



// WEBPACK FOOTER //
// src/components/ESSProfile/EmpGreenCard.vue